import { FC } from 'react';

import { localeKiosk } from '@lib/tools/locale/source/web/kiosk';

import fidelityCardIcon from '@components/web/src/assets/icons/detach_fidelity_icon.svg';
import * as S from '@components/web/src/atoms/Buttons/FidelityDetachButton/styles';
import { Image } from '@components/web/src/foundations/Image/Image';
import { Text } from '@components/web/src/foundations/Text/Text';

interface IProps {
  onClick: () => void;
}

export const FidelityDetachButton: FC<IProps> = ({ onClick }) => {
  const { fidelityCardLabel } = localeKiosk.fidelityDetachButton;
  return (
    <S.DetachFidelityCardButton onClick={onClick}>
      <Image alt="detach icon" height="16px" maxWidth="16px" minWidth="16px" src={fidelityCardIcon} />
      <Text size="body2" text={fidelityCardLabel} weight="medium" />
    </S.DetachFidelityCardButton>
  );
};
